import React, { useState } from "react";
import "./muiCheckbox.scss";
import {
  Checkbox,
  FormControlLabel,
  FormGroup,
  FormLabel,
} from "@mui/material";

const MuiCheckbox = ({
  checkboxes,
  boxLabel,
  onChange,
  value,
  defaultValue,
  defaultChecked,
}) => {
  const [checkedItems, setCheckedItems] = useState({});

  const handleCheckboxChange = (label) => {
    setCheckedItems((prevState) => ({
      ...prevState,
      [label]: !prevState[label],
    }));
  };
  if (boxLabel === "RevoFit®") console.log(defaultChecked);

  return (
    <div className="muiCheckbox">
      <FormLabel id="demo-radio-buttons-group-label">{boxLabel}</FormLabel>
      <FormGroup row>
        {checkboxes.map((checkbox, index) => (
          <FormControlLabel
            key={index}
            control={
              <Checkbox
                onChange={(e) => {
                  onChange(e, checkbox.id);
                  handleCheckboxChange(checkbox.id);
                }}
                defaultChecked={
                  defaultValue
                    ? defaultValue?.[checkbox?.id]
                    : defaultChecked
                    ? defaultChecked
                    : null
                }
                value={value}
              />
            }
            label={
              <div>
                {checkbox.displayName}
                {checkbox.desc && <p className="boxDesc">{checkbox.suffix}</p>}
              </div>
            }
            className={
              checkedItems?.[checkbox?.id]
                ? "checkedLabel"
                : defaultValue?.[checkbox?.id]
                ? "checkedLabel"
                : defaultChecked
                ? "checkedLabel"
                : ""
            }
          />
        ))}
      </FormGroup>
    </div>
  );
};

export default MuiCheckbox;
